import axios from "axios";

import ConvertObjectParamToString from "@/commons/ConvertObjectParamToString";

const deleteWarnDoc = "/api/telcoServices/deleteWarnDoc";
const baseApiFile = "/api/revenue/telcoServices/file?file_id=";
const FeeTyoe = "/api/business/feeType";
const CheckDuplicateCpn = "/api/business/check-duplicate-company";
const DoctypeListCreate = "/api/business/doc-type-list";
const DoctypeList = "/api/business/doc-type-for-eform-list";

const getListEform = "/api/business/eform-list";
export default class FromElectronicService {
  private convertObjectParamToStrings: ConvertObjectParamToString = ConvertObjectParamToString.instance;
  public getAllCompanies(params?: any, query?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`/api/business/company-for-eform?page=${params.page}&size=${params.size}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getBusinessCpn(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/company-type")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public getTypeOfDispatch(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/doc/bcdt-doc-types")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public createEform(query: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post("/api/business/create-eform", query)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public DoctypeListCreate(queryForm?: Array<number>): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(DoctypeListCreate + `?` + this.convertObjectParamToStrings.convertObjectParamToStrings(queryForm))
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public DoctypeList(queryForm?: Array<number>): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(DoctypeList + `?` + this.convertObjectParamToStrings.convertObjectParamToStrings(queryForm))
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public AllFeetype(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`/api/business/receipt/fee_types`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  // Pattern-detail
  public getPatternById(id: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`/api/business/sms/${id}/pattern-detail`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public CheckDuplicateCpn(querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(CheckDuplicateCpn, querySearch)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  // Danh sách biểu mẫu
  public getAllSMS(querySearch: any, params: any, cancelToken): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`/api/business/sms/pattern-search` + "?" + this.convertObjectParamToStrings.convertObjectParamToStrings(params), querySearch, { cancelToken: cancelToken.token })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  // chi tiết biểu mẫu
  public getDetail(id?: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`/api/business/eform?id=${id}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  // chi tiết biểu mẫu
  public getAllSMSTypes(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`/api/business/sms/types`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  // create
  public createSMSTypes(query: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`/api/business/sms/create-sms-pattern`, query)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  // update
  public updateSMSTypes(id: any, query: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .put(`/api/business/sms/${id}/pattern`, query)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  //delete e-form
  public deleteElform(id?: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`/api/business/delete-eform?id=${id}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  // edit el-form
  public EditElform(queryForm?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`/api/business/edit-eform`, queryForm)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  // Delete SmsComp
  public deleteSmsComp(id: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`/api/business/sms/${id}/delete`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
